import React from 'react';
import './ProblemSection.css';

const ProblemSection = () => {
  const problems = [
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
          <path d="M14 14h7v7" />
        </svg>
      ),
      title: 'Fragmented Information',
      description: 'Information are overintegrates that about information man the information'
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="12" y1="18" x2="12" y2="12" />
          <line x1="9" y1="15" x2="15" y2="15" />
        </svg>
      ),
      title: 'Reactive Guidance',
      description: 'Analyze in sjmentur sources other guidance reactives seats'
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
      ),
      title: 'Unverified Sources',
      description: 'Sources sources of eregnaes facts, unverified sources ants'
    }
  ];

  return (
    <section className="section problem-section">
      <div className="container">
        <h2 className="section-title">The Problem We Solve</h2>

        <div className="problem-content">
          <div className="problem-cards">
            {problems.map((problem, index) => (
              <div key={index} className="problem-card">
                <div className="problem-icon">
                  {problem.icon}
                </div>
                <div className="problem-text">
                  <h3 className="problem-title">{problem.title}</h3>
                  <p className="problem-description">{problem.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="dashboard-preview">
            <div className="dashboard-mockup">
              <div className="dashboard-header">
                <span className="dashboard-logo">12th<span className="plus">plus</span>.com</span>
                <span className="dashboard-title">Dashboard</span>
              </div>
              <div className="dashboard-content">
                <div className="dashboard-sidebar">
                  <div className="sidebar-item active"></div>
                  <div className="sidebar-item"></div>
                  <div className="sidebar-item"></div>
                  <div className="sidebar-item"></div>
                </div>
                <div className="dashboard-main">
                  <div className="stat-row">
                    <div className="stat-card orange"></div>
                    <div className="stat-card blue"></div>
                    <div className="stat-card green"></div>
                  </div>
                  <div className="chart-area">
                    <div className="chart-bar" style={{ height: '60%' }}></div>
                    <div className="chart-bar" style={{ height: '80%' }}></div>
                    <div className="chart-bar" style={{ height: '45%' }}></div>
                    <div className="chart-bar" style={{ height: '90%' }}></div>
                    <div className="chart-bar" style={{ height: '70%' }}></div>
                  </div>
                </div>
              </div>
              <div className="dashboard-badge">
                <span className="badge-logo">12th<span className="plus">plus</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
